import LeftSectionBlock from "../../components/LeftSectionBlock";
import RightSectionBlock from "../../components/RightSectionBlock";
import ArthurImage from "../../assets/images/team/arthur.png";
import RyanImage from "../../assets/images/team/ryan.png";
import RainImage from "../../assets/images/team/rain.png";
import ErriseImage from "../../assets/images/team/errise.png";
import MarkImage from "../../assets/images/team/mark.png";
import ArnelImage from "../../assets/images/team/arnel.png";
import PaolaImage from "../../assets/images/team/paola.png";
import MJImage from "../../assets/images/team/mj.png";
import DeaImage from "../../assets/images/team/dea.png";
import DanicaImage from "../../assets/images/team/danica.png";
import PaulImage from "../../assets/images/team/paul.png";
import KenImage from "../../assets/images/team/ken.png";
import DanImage from "../../assets/images/team/dan.png";
import MeriamImage from "../../assets/images/team/meriam.png";
import KarenImage from "../../assets/images/team/karen.png";
import ImoImage from "../../assets/images/team/imogen.png";
import KarlaImage from "../../assets/images/team/karla.png";
import AaronImage from "../../assets/images/team/aaron.png";
import JoemarImage from "../../assets/images/team/joemar.png";
import ErickImage from "../../assets/images/team/erick.png";

const MainContent = () => {
  return (
    <>
      <div className="team-page-container-blk executive-support-blk">
        <div className="header-blk-team-blk">
          <h1>Executive Support</h1>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={RyanImage} alt="Ryan Rayner" />
              </div>
              <div>
                <h2>Ryan Rayner</h2>
                <h3>Co-Founder & Chief Customer Officer</h3>
                <a href="mailto:ryan.rayner@icxeed.ai">ryan.rayner@icxeed.ai</a>
                <a href="tel:+61438286198">+61 438 286 198</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Business strategy, partnership opportunities, sales enquiries and
              solutions
            </p>
          </div>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={RainImage} alt="Rain Abueg" />
              </div>
              <div>
                <h2>Rain Abueg</h2>
                <h3>Co-Founder & Chief Culture Officer</h3>
                <a href="mailto:rain.abueg@icxeed.ai">rain.abueg@icxeed.ai</a>
                <a href="tel:+639175867892">+63 917 586 7892</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Strategic culture initiatives and values alignment, client and
              employee relations, organisational development
            </p>
          </div>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={ArthurImage} alt="Arthur Nowak" />
              </div>
              <div>
                <h2>Arthur Nowak</h2>
                <h3>Co-Founder & CEO</h3>
                <a href="mailto:arthur.nowak@icxeed.ai">
                  arthur.nowak@icxeed.ai
                </a>
                <a href="tel:+639176888464">+63 917 688 8464</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Long-term strategic initiatives, thought leadership, growth and
              innovation opportunities
            </p>
          </div>
        </div>
      </div>

      <div className="team-page-container-blk client-success-blk">
        <div className="header-blk-team-blk">
          <h1>Client Success</h1>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={MJImage} alt="MJ Mandayo" />
              </div>
              <div>
                <h2>MJ Mandayo </h2>
                <h3>Associate Director, Client Success</h3>
                <a href="mailto:mj.mandayo@icxeed.ai">mj.mandayo@icxeed.ai</a>
                <a href="tel:+639171743946">+63 917 174 3946</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Client success goals and measures, operational enquiries, process
              improvements, and issue resolution
            </p>
          </div>
        </div>
      </div>

      <div className="team-page-container-blk talent-culture-blk">
        <div className="header-blk-team-blk">
          <h1>Talent and Culture</h1>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={ErriseImage} alt="Errise Magnaye" />
              </div>
              <div>
                <h2>Errise Magnaye</h2>
                <h3>Associate Director, People and Culture</h3>
                <a href="mailto:errise.magnaye@icxeed.ai">
                  errise.magnaye@icxeed.ai
                </a>
                <a href="tel:+639175067540">+63 917 506 7540</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Onboarding and orientation planning, employee engagement
              initiatives, performance management guidance, wellbeing and
              support resources, HR policy clarification and compliance
            </p>
          </div>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={DeaImage} alt="Dea Saronhilo" />
              </div>
              <div>
                <h2>Dea Saronhilo</h2>
                <h3>Senior Recruiter</h3>
                <a href="mailto:dea.saronhilo@icxeed.ai">
                  dea.saronhilo@icxeed.ai
                </a>
                <a href="tel:+639393522294">+63 939 352 2294</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>Interview schedules, recruitment updates, candidate selection</p>
          </div>
        </div>

        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={KarenImage} alt="Karen Porte" />
              </div>
              <div>
                <h2>Karen Porte</h2>
                <h3>Learning Strategist</h3>
                <a href="mailto:karen.porte@icxeed.ai">karen.porte@icxeed.ai</a>
                <a href="tel:+639190034615">+63 919 003 4615</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Recruitmment strategy, interview schedules and updates, candidate
              selection
            </p>
          </div>
        </div>
      </div>

      <div className="team-page-container-blk business-services-blk">
        <div className="header-blk-team-blk">
          <h1>Business Services</h1>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={KarlaImage} alt="Karla Soriano" />
              </div>
              <div>
                <h2>Karla Soriano</h2>
                <h3>Finance Manager</h3>
                <a href="mailto:karla.soriano@icxeed.ai">
                  karla.soriano@icxeed.ai
                </a>
                <a href="tel:+639959032590">+63 995 903 2590</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Overall financial relationship and partnership. Payment terms and
              conditions, compliance with financial or regulatory requirements,
              payment disputes or delays, risk management related to payments or
              contracts
            </p>
          </div>
        </div>

        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={AaronImage} alt="Aaron Montero" />
              </div>
              <div>
                <h2>Arron Montero</h2>
                <h3>Financial Reporting and Invoicing Analyst</h3>
                <a href="mailto:arron.montero@icxeed.ai">
                  arron.montero@icxeed.ai
                </a>
                <a href="tel:+639695624048">+63 969 562 4048</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Invoicing or billing statements, billing information or contact
              details, clarifying charges or details, payment schedules, due
              dates, and processing timelines
            </p>
          </div>
        </div>

        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={PaolaImage} alt="Paola Rabilles" />
              </div>
              <div>
                <h2>Paola Rabilles</h2>
                <h3>Lead Project Manager</h3>
                <a href="mailto:paola.rabilles@icxeed.ai">
                  paola.rabilles@icxeed.ai
                </a>
                <a href="tel:+639190016771">+63 919 001 6771</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              invoicing or billing statements, billing information or contact
              details, clarifying charges or details, payment schedules, due
              dates, and processing timelines
            </p>
          </div>
        </div>

        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={DanicaImage} alt="Danica Antenero" />
              </div>
              <div>
                <h2>Danica Antenero</h2>
                <h3>Business Requirements Engineer</h3>
                <a href="mailto:danica.antenero@icxeed.ai">
                  danica.antenero@icxeed.ai
                </a>
                <a href="tel:+639280844143">+63 9280 844 143</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Business process optimisation, requirements analysis and
              translation, technology and system analysis, data-driven
              recommendations
            </p>
          </div>
        </div>

        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={PaulImage} alt="Paul Layacan" />
              </div>
              <div>
                <h2>Paul Layacan</h2>
                <h3>Lead Software Engineer</h3>
                <a href="mailto:paul.layacan@icxeed.ai">
                  paul.layacan@icxeed.ai
                </a>
                <a href="tel:+639175175572">+63 917 517 5572</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Website creation and design, functionality and performance,
              integration of third-party tools, mobile optimisation, e-commerce
              solutions
            </p>
          </div>
        </div>

        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={KenImage} alt="Kenneth Sarte" />
              </div>
              <div>
                <h2>Kenneth Sarte</h2>
                <h3>UI/UX Designer</h3>
                <a href="mailto:kenneth.sarte@icxeed.ai.ai">
                  kenneth.sarte@icxeed.ai
                </a>
                <a href="tel:+639175175572">+63 917 517 5572</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              User experience enhancement, intuitive and user-friendly
              interfaces, visual design and brand perception, customer
              engagement and retention
            </p>
          </div>
        </div>
      </div>

      <div className="team-page-container-blk executive-support-blk">
        <div className="header-blk-team-blk">
          <h1>Amazon Connect, Gen AI, and AWS Services</h1>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={ArnelImage} alt="Arnel Clave" />
              </div>
              <div>
                <h2>Arnel Clave(AWS)</h2>
                <h3>Lead Solution Architect (AWS)</h3>
                <a href="mailto:arnel.clave@icxeed.ai">arnel.clave@icxeed.ai</a>
                <a href="tel:+639164499913">+63 916 449 9913</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Technical approach and architecture design, align solution with
              business goals and stakeholder requirements, project execution
            </p>
          </div>
        </div>

        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={MeriamImage} alt="Meriam Tuano" />
              </div>
              <div>
                <h2>Meriam Tuano</h2>
                <h3>Quality Engineer</h3>
                <a href="mailto:meriam.tuano@icxeed.ai">
                  meriam.tuano@icxeed.ai
                </a>
                <a href="tel:+639663290673">+63 966 329 0673</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Quality assurance through functional and non-functional testing
            </p>
          </div>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={JoemarImage} alt="Joemar Rabaja" />
              </div>
              <div>
                <h2>Joemar Rabaja</h2>
                <h3>Lead Cloud Developer</h3>
                <a href="mailto:joemar.rabaja@icxeed.ai">
                  joemar.rabaja@icxeed.ai
                </a>
                <a href="tel:+639152361024">+63 915 236 1024</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Project technical direction, align development with client
              requirements, technical challenges and solutions, integration with
              existing systems
            </p>
          </div>
        </div>
        <div className="flex-box-blk">
          <div>
            <div className="flex-box-blk">
              <div>
                <img src={ErickImage} alt="Erick Llanita" />
              </div>
              <div>
                <h2>Erick Llanita</h2>
                <h3>Senior Cloud Developer</h3>
                <a href="mailto:johnerick.llanita@icxeed.ai">
                  johnerick.llanita@icxeed.ai
                </a>
                <a href="tel:+639564687296">+63 956 468 7296</a>
              </div>
            </div>
          </div>
          <div>
            <div className="divider-blk"></div>
            <p>
              Align development with client requirements, technical challenges
              and solutions, troubleshoot bugs or performance issues,
              improvements and optimizations
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const OurTeamPage = () => {
  return (
    <div className="main-container-blk">
      <div className="main-section-blk">
        <LeftSectionBlock />
        <RightSectionBlock
          title="OUR TEAM AT iCXeed"
          stringBlurb="Here are some of the people you'll be working with."
          previousBtn="/introduction"
          nextBtn="/our-dna"
          mainContent={<MainContent />}
        />
      </div>
    </div>
  );
};

export default OurTeamPage;
